// English translation

const en = {
  "menu.party": "Party",
  "party.party": "Party",
  "party.party.name": "Name",
  "party.party.id_number": "ID Number",
  "party.party.nationality": "Nationality",
  "party.party.sex": "Sex",
  "party.party.main_mobile": "Mobile",
  "party.party.main_email": "Email",
  "party.party.street": "Street",
  "party.party.subdivision": "Subdivision",
  "party.party.country": "Country",
  "party.party.city": "City",
  "party.party.type_document": "Type Document",
  "party.party.type_person": "Person Type",
  "party.party.birthday": "Birthday",
  "tryton.id_number_already_exists": "ID number already exists",
  "party.party.validation.invalid_name": "Invalid name format",
  "party.party.validation.invalid_email": "Invalid email format",
  "party.party.validation.invalid_phone":
    "Phone must have between 7 and 15 digits",
  "party.party.validation.invalid_IdNumber": "Invalid Identification number",
  "party.party.validation.invalid_date": "Invalid date format",
  "party.party.validation.client_dian": "No DIAN record found",
  "party.party.report":"Portfolio Statement Report"
};

export default en;
